import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import {
  Md2DataTableModule,
  Md2DialogModule,
  MdCommonModule,
  Md2TooltipModule,
  Md2DatepickerModule,
  Md2SelectModule
} from 'md2';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgCircleProgressModule } from 'ng-circle-progress';

import { SharedModule } from '../shared/shared.module';
import { CommonFunctioModule } from '../common/commonFunction.module';
import { GenericUiModule } from '../generic-ui-components/generic.ui.module';
import { NgMultiSelectDropDownModule } from '../common/ng-multiselect-dropdown/src/ng-multiselect-dropdown.module';
import { PendingInvoicesPopupComponent } from './pending-invoices-popup/pending-invoices-popup.component';

@NgModule({
  imports: [
    CommonModule,
    CommonFunctioModule,
    SharedModule,
    Md2DataTableModule,
    FormsModule,
    GenericUiModule,
    NgxPaginationModule,
    Md2SelectModule,
    Md2DatepickerModule,
    MatInputModule,
    Md2DialogModule,
    Md2TooltipModule,
    MdCommonModule,
    NgMultiSelectDropDownModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgCircleProgressModule.forRoot({
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: '#78C000',
      innerStrokeColor: '#C7E596',
      animationDuration: 300
    })
  ],
  declarations: [PendingInvoicesPopupComponent],
  exports: [PendingInvoicesPopupComponent]
})
export class AllCompanyDashboardCommonModule {}



// WEBPACK FOOTER //
// /codebuild/output/src3653757523/src/src/app/all-company-dashboard/common.module.ts